import { useState, Dispatch, SetStateAction } from 'react'
import { IconButton, MenuItem } from '@mui/material'
import { DraftProps } from 'container/Home/components/Banners/interface'
import ModalVerOvs from 'container/SalesOrder/components/ModalVerOvs'
import {
  asyncGetCorpoRascunho,
  setDuplicateOrder
} from 'store/SalesOrderContext/salesOrderSlice'

import * as S from './styles'
import { useDispatch, useSelector } from 'store/store'
import { FormatBodyType } from 'container/ManageOrders/utils'
import { CustomBoolean, TypesValidations } from 'constants/enums'
import { Icon } from 'components'
import { theme } from 'styles/theme/hav-theme'

type SalesOrderMenuProps = {
  draft: DraftProps
  getOrdersData: (body?: FormatBodyType) => Promise<void>
  draftsPage: number
  setSelectedDraft: Dispatch<SetStateAction<string>>
  selectedDraft: string
  setModalDuplicate: Dispatch<SetStateAction<boolean>>
  setModalPostOn: Dispatch<SetStateAction<boolean>>
  modalDuplicate: boolean
}

const SalesOrderMenu = ({
  draft,
  setSelectedDraft,
  selectedDraft,
  setModalDuplicate,
  setModalPostOn,
  modalDuplicate
}: SalesOrderMenuProps) => {
  const dispatch = useDispatch()
  const { duplicateOrder } = useSelector(({ salesOrder }) => salesOrder)
  const [modalVerOvs, setModalVerOvs] = useState(false)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickDuplicate = () => {
    setModalDuplicate(!modalDuplicate)
  }

  const openPostOn = () => {
    setModalPostOn(true)
  }

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    nrDraft: string,
    fl_mto_prep: CustomBoolean,
    cd_clie: string
  ) => {
    event.preventDefault()
    setSelectedDraft(nrDraft)
    setAnchorEl(event.currentTarget)
    dispatch(asyncGetCorpoRascunho(nrDraft))
    dispatch(
      setDuplicateOrder({
        ...duplicateOrder,
        nr_pedi_rasc_orig: nrDraft,
        Clientes: [
          {
            cd_clie: cd_clie,
            fl_mto_prep: fl_mto_prep,
            fl_dupl_matr: TypesValidations.YES,
            fl_dupl_text: TypesValidations.YES,
            nr_pedi_clie: ''
          }
        ]
      })
    )
  }

  return (
    <>
      <IconButton
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        type="button"
        onClick={(e) => {
          handleClick(
            e,
            draft.NumeroPedidoRascunho,
            draft.TipoMaterial,
            draft.CodigoCliente
          )
        }}
        style={{
          width: 30,
          height: 30,
          padding: 0,
          borderRadius: 5,
          background: '#fff'
        }}
      >
        <Icon icon="ellipsis" color={theme.colors.primary.main} size="15" />
      </IconButton>
      <S.MenuStyled
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open && draft.NumeroPedidoRascunho === selectedDraft}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            handleClickDuplicate()
            handleClose()
          }}
        >
          Duplicar
        </MenuItem>

        <MenuItem
          onClick={() => {
            openPostOn()
            handleClose()
          }}
        >
          Listar
        </MenuItem>
        {draft.OrdensVendas.length > 0 && (
          <MenuItem
            onClick={() => {
              setModalVerOvs(true)
              handleClose()
            }}
          >
            Ver OVs
          </MenuItem>
        )}
      </S.MenuStyled>
      <ModalVerOvs
        ordensVenda={draft.OrdensVendas}
        orderNumber={draft.NumeroPedidoRascunho}
        isOpen={modalVerOvs && selectedDraft === draft.NumeroPedidoRascunho}
        setIsOpen={setModalVerOvs}
      />
    </>
  )
}

export default SalesOrderMenu
